import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { Outlet } from "react-router-dom";

export default function AuthContainer() {

    return (
        <Box display="flex" height="100%" overflow="auto">
            <Container maxWidth="sm" fixed sx={{ mt: 4 }}>
                <Paper>
                    <Outlet />
                </Paper>
            </Container>
        </Box >
    );
}